import { render } from "./InstallAppBanner.vue?vue&type=template&id=2cec8a13"
import script from "./InstallAppBanner.vue?vue&type=script&lang=js"
export * from "./InstallAppBanner.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dgvt/dgvt-fuchs.de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__